import React, { useState, useRef, useEffect, useCallback } from 'react';
import Iconify from 'src/components/Iconify';
import useAuth from 'src/hooks/useAuth';
import v2_actionCrmPesquisarLeads from 'src/actions/v2/crm/v2_actionCrmPesquisarLeads';
import { getIniciais } from '../Propostas.design';
import { formatCurrency } from './OrcamentoItens';
import { DOCUMENTO_DESIGN as D } from '../EditorDocumento.design';

// Busca de lead do CRM com resultados em dropdown. Usada no orçamento e no
// painel do editor de proposta; quem usa decide o que fazer com o lead escolhido.
export default function LeadSearch({ onSelect, placeholder = 'Buscar lead no CRM pelo nome', autoFocus, disabled }) {
  const { user } = useAuth();
  const [termo, setTermo] = useState('');
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [aberto, setAberto] = useState(false);
  const debounceRef = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    const fechar = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setAberto(false); };
    document.addEventListener('mousedown', fechar);
    return () => document.removeEventListener('mousedown', fechar);
  }, []);

  const buscar = useCallback((texto) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!texto || texto.trim().length < 2) { setResultados([]); setAberto(false); return; }
    setBuscando(true);
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await v2_actionCrmPesquisarLeads(`?cliente_id=${user?.clienteId}&termo_pesquisa=${encodeURIComponent(texto.trim())}&limite=8`);
        setResultados(res.data?.data || res.data || []);
      } catch (error) {
        console.error('Erro ao pesquisar leads:', error);
        setResultados([]);
      } finally {
        setBuscando(false);
        setAberto(true);
      }
    }, 300);
  }, [user?.clienteId]);

  const selecionar = (item) => {
    onSelect(item);
    setTermo('');
    setResultados([]);
    setAberto(false);
  };

  return (
    <div className={D.search} ref={wrapRef}>
      <Iconify icon={buscando ? 'mdi:loading' : 'eva:search-outline'} width={16} className={`${D.searchIcon} ${buscando ? 'animate-spin' : ''}`} />
      <input
        className={`${D.input} pl-9`}
        value={termo}
        onChange={e => { setTermo(e.target.value); buscar(e.target.value); }}
        onFocus={() => { if (resultados.length) setAberto(true); }}
        placeholder={placeholder}
        autoComplete="off"
        autoFocus={autoFocus}
        disabled={disabled}
        aria-label="Buscar lead no CRM"
      />
      {aberto && (
        <div className={D.dropdown}>
          {resultados.length === 0 ? (
            <p className={D.dropdownEmpty}>Nenhum lead com esse nome.</p>
          ) : resultados.map(item => (
            <button key={item._id} type="button" className={D.dropdownItem} onClick={() => selecionar(item)}>
              <span className={D.avatarSm}>{getIniciais(item.nome)}</span>
              <span className="min-w-0 flex-1">
                <span className={`${D.personName} block`}>{item.nome}</span>
                {item.valor !== undefined && item.valor !== null && (
                  <span className={`${D.personMeta} block`}>{formatCurrency(item.valor)}</span>
                )}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
